// src/components/NotFoundRedirect.js
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const NotFoundRedirect = () => {
  const user = useSelector((state) => state.auth?.auth);
  const isLoggedIn = !!user?._id;
  const role = user?.role;

  console.log("User Role:", role);

  // 🔹 If not logged in → redirect based on intended role (or default to customer)
  if (!isLoggedIn) {
    if (role === "vendor") {
      return <Navigate to="/vendor/auth/login" replace />;
    }
    return <Navigate to="/customer/search-brokers" replace />;
  }

  // 🔹 If logged in → redirect based on role
  switch (role) {
    case "customer":
      return <Navigate to="/customer/search-brokers" replace />;
    case "vendor":
      return <Navigate to="/vendor/dashboard" replace />;
    default:
      return <Navigate to="/customer/search-brokers" replace />; // fallback
  }
};

export default NotFoundRedirect;
